import React, { useEffect, useRef } from "react";
import { useCreation } from "ahooks";
import { useDispatch, useSelector } from "react-redux";
import styles from "./preview.module.scss";
import { AISaasPreview } from "../AISaas";
import { studioActions } from "@store/studio";
import { CheckedUIListType } from "@custom-hooks/HomeUsePluginRoot/state/useSaasAndThinkAppState";
import { Signal } from "@preact/signals-react";
import { useHomeChildContainer } from "@custom-hooks/HomeUsePluginRoot/childContainer";
import { WEB_APP_DEFAULT_SUBTITLE, WEB_APP_DEFAULT_TITLE } from "@views/thinking-layout-editor/constants";
import { useHomeUsePluginContainer } from "@custom-hooks/HomeUsePluginRoot";
import func from "@uikit/func";
import useFeatureTags from "@custom-hooks/useFeatureTags";
import { PreviewPaneBloc } from "./PreviewPaneBloc";
import { ThemeType } from "imagica-corekit/dist/cases/theme/appTheme/AiAppThemeData";
import { ChatThemeType } from "imagica-corekit/dist/cases/theme/chatTheme/ChatAppThemeData";
import { FontType } from "imagica-corekit/dist/cases/theme/fontTheme/FontData";

import { SettingPage } from "./Settings";

interface Props {
  backPreview: () => void;
  inOrOutSetting: (bol: boolean) => void;
  isShowPublish: boolean; // publish disable时 隐藏返回按钮
  silderState: Signal<boolean>;
  setPreviewShowStatus: (bol: boolean) => void;
  previewContainer: React.RefObject<HTMLDivElement>;
  setSaasTheme: (theme: any) => void;
  showSetting: boolean;
}

const Preview: React.FC<Props> = props => {
  const { setSaasTheme } = props;
  const previewRef = useRef(null);
  const feature_tags = useFeatureTags();
  const { backPreview, inOrOutSetting, silderState, setPreviewShowStatus } = props;
  const { clickRunAllBtn, handleHiddenNode, autoSelectTemplate, getUIListParam } = useHomeChildContainer();
  const {
    isNewEdgeRunRef,
    saasAndThinkState: { firstCreateProjectRef, saasUIData, setSaasUIData },
  } = useHomeUsePluginContainer();

  const { theme, settings } = saasUIData;
  const isChatApp = saasUIData?.v2App?.type === "chat_ai";
  const dispatch = useDispatch();
  const setSelectedTemplate = (val: any) => {
    dispatch(studioActions.setSelectedTemplate(val));
  };
  const selectedTemplate = useSelector((state: any) => state.studio.selectedTemplate);

  const bloc = useCreation(
    () =>
      new PreviewPaneBloc({
        setSaasUIData,
        themeContainer: props.previewContainer,
      }),
    []
  );

  const firstCreateProjectToCreateAiApp = async () => {
    const arr = [
      {
        label: "AI App",
        value: "saas",
        isStaticApp: false,
      } as CheckedUIListType,
    ];

    let uilist: any[] = getUIListParam(arr);
    uilist.forEach(item => {
      item.title = WEB_APP_DEFAULT_TITLE;
      item.subTitle = WEB_APP_DEFAULT_SUBTITLE;
      item.input = [];
      item.output = [];
      item.staticMode = false;
    });

    try {
      uiDataHandle(false);
      const data = isNewEdgeRunRef.current
        ? { ...selectedTemplate, v3: { ...selectedTemplate.v3, UI: [...uilist] } }
        : { ...selectedTemplate, v2: { ...selectedTemplate.v2, UI: [...uilist] } };
      setSelectedTemplate(data);
    } catch (error) {
      func.messageError(error);
    }
  };

  function uiDataHandle(sameTemplate: boolean) {
    if (!sameTemplate) {
      setSaasUIData(prev => ({ ...prev, input: [], output: [] }));
    }
    autoSelectTemplate(sameTemplate ? false : true, sameTemplate ? false : true);
  }

  useEffect(() => {
    if (feature_tags.enablePublishV3) {
      if (isChatApp) {
        bloc.changeChatTheme(theme as ChatThemeType);
      } else {
        bloc.changeTheme(theme as ThemeType);
      }
    } else {
      setSaasTheme(theme);
    }
  }, [bloc, feature_tags.enablePublishV3, isChatApp, setSaasTheme, theme]);

  useEffect(() => {
    if (feature_tags.enablePublishV3) {
      const fontFamily = settings?.fontFamily || FontType.AKREGULAR;
      bloc.changeFont(fontFamily as unknown as FontType);
    }
  }, [bloc, feature_tags.enablePublishV3, settings?.fontFamily]);

  useEffect(() => {
    if (feature_tags.enableAutoCreateAIApp) {
      //  创建Project时，自动打开preview且只执行一次
      if (firstCreateProjectRef.current) {
        firstCreateProjectRef.current = false;
        setPreviewShowStatus(true);
      }
    }
    // eslint-disable-next-line
  }, [firstCreateProjectRef]);

  return (
    <div ref={previewRef} className={`${styles.previewPage} ${props.showSetting ? styles.newPreviewPage : ""}`}>
      <AISaasPreview
        handleHiddenNode={handleHiddenNode}
        clickRunAllBtn={clickRunAllBtn}
        silderState={silderState}
        backPreview={backPreview}
        inOrOutSetting={inOrOutSetting}
      />
      <SettingPage bloc={bloc} />
    </div>
  );
};

export default Preview;
